import LTR from "@brand-icons/ploom/credit-card-blocked/credit-card-blocked-ltr.svg";
import RTL from "@brand-icons/ploom/credit-card-blocked/credit-card-blocked-rtl.svg";

import { iconFactory } from "../iconFactory";

export const CreditCardBlockedIcon = iconFactory("CreditCardBlockedIcon", LTR, RTL);
